import { CustomerCompanyMessage } from '../../types/CustomerCompanyMessage';
import { SupplierCompanyMessage } from '../../types/SupplierCompanyMessage';
import { BooleanStatus } from '../common/BooleanStatus/BooleanStatus';
import { DataSheet } from '../common/DataSheet/DataSheet';
import { formatAddress } from '../common/helpers/formatAddress.helper';
import { notAvailable } from '../common/helpers/notAvailable.helper';
import { translate } from '../common/helpers/translate.helper';
import { useRole } from '../common/hooks/useRole';
import { Box } from '../common/ui/Box';

interface GeneralInformationDatasheetProps {
    companyData: CustomerCompanyMessage | SupplierCompanyMessage;
}

export const GeneralInformationDatasheet = ({ companyData }: GeneralInformationDatasheetProps) => {
    const role = useRole();

    return (
        <Box display="flex" flexDirection={['column', 'column', 'row']} gap={32}>
            <Box flex="1">
                <DataSheet>
                    <DataSheet.Label>{translate('company.internalName')}</DataSheet.Label>
                    <span>
                        {notAvailable({
                            value: companyData.internalName,
                        })}
                    </span>

                    <DataSheet.Label>{translate('global.contact.email')}</DataSheet.Label>
                    <span>
                        {notAvailable({
                            value: companyData.email,
                        })}
                    </span>

                    <DataSheet.Label>{translate('global.contact.phone')}</DataSheet.Label>
                    <span>
                        {notAvailable({
                            value: companyData.phone,
                        })}
                    </span>

                    <DataSheet.Label>{translate('global.contact.fax')}</DataSheet.Label>
                    <span>
                        {notAvailable({
                            value: companyData.fax,
                        })}
                    </span>
                </DataSheet>
            </Box>
            <Box flex="1">
                <DataSheet>
                    <DataSheet.Label>{translate('global.contact.title')}</DataSheet.Label>
                    <span>
                        {notAvailable({
                            value: formatAddress({
                                address: companyData.address,
                            }),
                        })}
                    </span>

                    <DataSheet.Label>{translate('global.contact.invoicemail')}</DataSheet.Label>
                    <span>
                        {notAvailable({
                            value: companyData.invoiceMail,
                        })}
                    </span>

                    {role.isSuperAdmin() ? (
                        <>
                            <DataSheet.Label>{translate('global.mailsettings.receiveNews')}</DataSheet.Label>
                            <BooleanStatus value={companyData.mailSettings.newsletter} />
                        </>
                    ) : null}
                </DataSheet>
            </Box>
        </Box>
    );
};
